angular.module('ui.order.orderItemCard', [
    'ui.order.orderItemCard.orderItemCardDataProvider',
    'ui.order.orderItemCard.orderItemActions',
    'ui.order.orderItemCard.orderItemComments',
    'ui.order.orderItemCard.orderItemFiles',
    'ui.order.orderItemCard.orderReports',
    'ui.order.orderItemCard.orderItemInfo'
])

    .directive('orderItemCard', function () {
        return {
            restrict: 'E',
            controller: 'OrderItemCardController',
            controllerAs: 'OrderItemCardController',
            templateUrl: 'app/ui/order/orderItemCard/orderItemCard.html',
            scope: {
                orderItemId: '@orderItemId',

                onLoadStart: '&',
                onLoadEnd: '&',
                onAfterActionExecute: '&',
                onBeforeActionExecute: '&'
            }
        };
    })

    .controller('OrderItemCardController', function ($timeout, $log, $state, $scope, $q, toastr, gettextCatalog, userSettings, orderItemsGridSharedSettings,
        orderItemCardDataProvider, orderDetailsControllerUpdatesService, usersRepository, customResourceResolver, $customisationConfig, geocodingService) {
        $scope.tabs = [
            {
                title: gettextCatalog.getString("Info"),
                name: "info"
            },
            {
                title: gettextCatalog.getString("Notes"),
                name: "notes"
            },
            {
                title: gettextCatalog.getString("Files"),
                name: "files"
            },
            {
                title: gettextCatalog.getString("Reports"),
                name: "reports"
            }
        ];
        var stepsConfig;

        _.extend($scope, {
            executeAction: executeAction,
            setCurrentTab: setCurrentTab,
            shareOrderItem: shareOrderItem,
            getOrderItemShareLink: getOrderItemShareLink,
            getOrderItemEmailShareLink: getOrderItemEmailShareLink,
            showHideShareDialog: showHideShareDialog,
            shareItemViaTg: shareItemViaTg,
            copyOrderItemLink: copyOrderItemLink,
            getItemStepIconName: getItemStepIconName,
            viewCustomerOrders: viewCustomerOrders
        });

        initController();

        function initController() {
            $scope.isHiddenSummary = false;
            $scope.isBusy = false;
            $scope.showNonSystemShareDialog = false;
            $scope.copiedToBuffer = false;

            setCurrentTab();
            initData();
            initWatchers();
            initSignalREvents();
        }

        function initData(force) {
            if (!force && $scope.orderItemId === orderItemCardDataProvider.getOrderItemId()) {
                return;
            }

            onLoadStart();
            orderItemCardDataProvider.setOrderItemId($scope.orderItemId, force);

            initWorkflowConfig();
        }

        function initWorkflowConfig() {
            return usersRepository.getCurrentUser().then(function (restUser) {
                $scope.isCustomer = restUser.isCustomer();

                customResourceResolver.resolveWorkflow().then(function (workflowConfig) {
                    stepsConfig = workflowConfig.steps;
                });

            });
        }

        function processOrderItemInfo() {
            $scope.orderDeliveryAddressPlace = null;

            if (!$scope.order) return;

            geocodingService.getGeocodingForAddress($scope.order.$model.deliveryAddress.toFormattedString())
                .then(function(result) {
                    $scope.orderDeliveryAddressPlace = result;
                });
        }

        function getItemStepIconName() {
            if ($scope.orderItem && angular.isDefined(stepsConfig)) {
                var stepConfig = _.find(stepsConfig, function (s) { return s.code === $scope.orderItem.$model.stepCode; });
                var step = $scope.orderItem.$model.step;
                var noIcon = angular.isDefined(stepConfig) && angular.isDefined(stepConfig.noImageOnHomeView) && stepConfig.noImageOnHomeView === true;
                var fallbackIconForStep = function (stepCode) {
                    return $customisationConfig.hasResource(function (res) { return _.string.contains(res, stepCode + "."); }) ? stepCode : "workflow";
                };

                var stepIcon = !noIcon
                    ? (angular.isUndefined(stepConfig)
                        ? fallbackIconForStep(step.code) : (angular.isDefined(stepConfig.publicImageResourceName) && $scope.isCustomer
                            ? stepConfig.publicImageResourceName : (angular.isDefined(stepConfig.imageResourceName)
                                ? stepConfig.imageResourceName : fallbackIconForStep(step.code)))) : "";

                return stepIcon;
            }

            return '';
        }

        function initWatchers() {
            orderItemCardDataProvider.onDataChange('OrderItemCardController', function () {
                $scope.orderItemId = orderItemCardDataProvider.getOrderItemId();

                if (!$scope.orderItemId) {
                    $scope.orderItem = null;
                    $scope.step = null;
                    $scope.order = null;
                    $scope.categories = null;
                    $scope.categoryTypes = null;
                    $scope.orderItemCategories = null;
                    $scope.orderItemWorkflowAudit = null;
                } else {
                    $scope.orderItem = orderItemCardDataProvider.getOrderItem();
                    $scope.step = orderItemCardDataProvider.getStep();
                    $scope.order = orderItemCardDataProvider.getOrder();
                    $scope.categories = orderItemCardDataProvider.getCategories();
                    $scope.categoryTypes = orderItemCardDataProvider.getCategoryTypes();
                    $scope.orderItemCategories = orderItemCardDataProvider.getOrderItemCategories();
                    $scope.orderItemWorkflowAudit = orderItemCardDataProvider.getOrderItemWorkflowAudit();

                    processOrderItemInfo();
                }

                onLoadEnd();
            });

            $scope.$watch('orderItemId', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    $scope.$applyAsync(function() {
                        initData();
                    });
                }
            });

            $scope.$on("$destroy", function () {
                orderDetailsControllerUpdatesService.onNewOrderItem(void 0);
                orderDetailsControllerUpdatesService.onOrderItemChanged(void 0);
                orderDetailsControllerUpdatesService.onOrderChanged(void 0);
                orderItemCardDataProvider.onDataChange('OrderItemCardController', void 0);
            });
        }

        function initSignalREvents() {
            orderDetailsControllerUpdatesService.onOrderItemChanged(function (modelInfo) {
                if ($scope.isBusy) {
                    return;
                }

                if ($scope.orderItem && modelInfo.id == $scope.orderItem.getId()) {
                    initData();
                }
            });
        }

        function viewCustomerOrders() {
            if ($scope.orderItem) {
                orderItemsGridSharedSettings.setSelectedOrderItemId($scope.orderItem.getId());
                
                //$state.go('client.orders', { step: 'all-open', search: $scope.order.$model.customer.$model.address.$model.companyName , exact: true});
                //orderItemsGridSharedSettings.setTextSearch($scope.order.$model.customer.$model.address.$model.companyName, true);

                $state.go('client.customer', { customerId: $scope.order.$model.customer.getId() });
            }
        }

        function getOrderItemShareLink() {
            return _.str.sprintf('%s%s#/client/orders/all-open/details/%s',
                om.config.build.originUrl,
                om.config.build.electronRemoteUrl,
                $scope.orderItemId);
        }

        function shareOrderItem() {
            if ($scope.orderItemId && $scope.orderItem) {
                if (navigator.share) {
                    navigator.share({
                        title: 'Order Manager',
                        text: 'View Order Item ' + $scope.orderItemId,
                        url: getOrderItemShareLink()
                    }).then(function () {
                        //shared
                    },
                        function (e) {
                            $log.error('Error during sharing of the Order Item.', e);
                        });
                } else {
                    //Sharing not supported by the agent
                    $scope.showNonSystemShareDialog = !$scope.showNonSystemShareDialog;
                }
            }
        }

        function getOrderItemEmailShareLink() {
            var subject = _.str.sprintf(gettextCatalog.getString('View Item %s in OrderManager'), $scope.orderItemId);
            var messageToShare = _.str.sprintf(gettextCatalog.getString('Check out Item %s at %s'), $scope.orderItemId, getOrderItemShareLink());
            var url = _.str.sprintf('mailto:?subject=%s&body=%s', encodeURIComponent(subject), encodeURIComponent(messageToShare));
            return url;
        }

        function shareItemViaTg() {
            var messageToShare = _.str.sprintf(gettextCatalog.getString('%sCheck out Item %s in OrderManager'), String.fromCharCode(13), $scope.orderItemId);
            window.location = _.str.sprintf('tg://msg_url?text=%s&url=%s', encodeURIComponent(messageToShare), encodeURIComponent(getOrderItemShareLink()));
            showHideShareDialog();
        }

        function copyOrderItemLink() {
            if (navigator.clipboard && navigator.clipboard.writeText &&
                navigator.permissions && navigator.permissions.query) {

                var queryOpts = { name: 'clipboard-write' };
                navigator.permissions.query(queryOpts).then(function (permissionStatus) {
                    if (permissionStatus.state === 'granted') {
                        navigator.clipboard.writeText(getOrderItemShareLink()).then(function () {
                            $scope.copiedToBuffer = true;
                            $timeout(function () {
                                $scope.copiedToBuffer = false; //switch off to re-set icon
                                showHideShareDialog();
                            },
                                1500);
                        },
                            function (err) {
                                $log.error('Failed to copy Item url into clipboard :(', err);
                            });
                    } else {
                        alert(gettextCatalog.getString('Copying into Clipboard has not been granted for OrderManager in your browser :('));
                    }
                });
            } else {
                alert(gettextCatalog.getString('Error during copying Order Item URL to Clipboard :('));
            }
        }

        function showHideShareDialog() {
            $scope.showNonSystemShareDialog = !$scope.showNonSystemShareDialog;
        }

        function setCurrentTab(tab) {
            userSettings.getSettings().then(function (settings) {
                if (!tab) {
                    tab = $scope.tabs[0]; // default tab
                    if (settings.saveOrderItemCardTab === true || settings.saveOrderItemCardTab === "true") {
                        var savedTab = _.find($scope.tabs, function (tab) {
                            return tab.name === settings.orderItemCardTab;
                        });
                        tab = savedTab || tab;
                    }
                }
                $scope.currentTab = tab;
                settings.orderItemCardTab = $scope.currentTab.name;
                userSettings.save();
            });
        }

        var actionIsExecuting;

        function executeAction(actionCode) {
            if (actionIsExecuting || $scope.isBusy) {
                return;
            }
            actionIsExecuting = true;
            onLoadStart();

            var unlinkedCategories = _.where($scope.categories, { isLinked: false });
            var linkedCategories = _.where($scope.categories, { isLinked: true });

            onBeforeActionExecute();

            orderItemCardDataProvider.executeAction(actionCode, unlinkedCategories, linkedCategories)

                .then(function () {
                    return onAfterActionExecute();
                }, function () {
                    return onAfterActionExecute();
                })

                .then(function () {
                    actionIsExecuting = false;
                    onLoadEnd();
                    initData(true);
                });
        }

        function onLoadStart() {
            $scope.isBusy = true;
            if ($scope.onLoadStart) {
                $scope.onLoadStart();
            }
        }

        function onLoadEnd() {
            $scope.isBusy = false;
            if ($scope.onLoadEnd) {
                $scope.onLoadEnd();
            }
            $scope.orderItemShareLink = getOrderItemShareLink();
        }

        function onAfterActionExecute() {
            if ($scope.onAfterActionExecute) {
                return $scope.onAfterActionExecute();
            }
            return $q.when(true);
        }

        function onBeforeActionExecute() {
            if ($scope.onBeforeActionExecute) {
                return $scope.onBeforeActionExecute();
            }

            return null;
        }

    })

    // Separate service for update events (to prevent multiple event subscription)
    .service('orderDetailsControllerUpdatesService', function (rest) {
        var _this = this;
        var newOrderItemCb;
        var orderItemChangedCb;
        var orderChangedCb;

        rest.events.on("modelCreatedOnServer", function (modelInfo) {
            if (!newOrderItemCb) {
                return;
            }
            if (modelInfo && modelInfo.modelType === "OrderItemModel") {
                newOrderItemCb(modelInfo);
            }
        });

        rest.events.on("modelUpdatedOnServer", function (modelInfo) {
            if (modelInfo.modelType === "OrderItemModel" && orderItemChangedCb) {
                orderItemChangedCb(modelInfo);
            } else if (modelInfo.modelType === "OrderModel" && orderChangedCb) {
                orderChangedCb(modelInfo);
            }
        });

        _this.onNewOrderItem = function (cb) {
            newOrderItemCb = cb;
        };

        _this.onOrderItemChanged = function (cb) {
            orderItemChangedCb = cb;
        };

        _this.onOrderChanged = function (cb) {
            orderChangedCb = cb;
        };

        return _this;
    })

    ;
